/* Shared basket and checkout address contract. UK delivery only. */
(function () {
  'use strict';
  function normalise(input) {
    var a = {};
    ['name','line1','line2','city','postcode','phone'].forEach(function (k) {
      a[k] = String((input || {})[k] || '').trim().replace(/\s+/g, ' ');
    });
    a.postcode = a.postcode.toUpperCase().replace(/\s/g, '').replace(/(.+)(.{3})$/, '$1 $2');
    return a;
  }
  function error(input) {
    var a = normalise(input), labels = {name:'recipient’s full name',line1:'street address',city:'town or city',postcode:'postcode'};
    for (var key in labels) if (!a[key]) return {field:key, text:'Enter the ' + labels[key] + '.'};
    if (!/^(GIR 0AA|([A-PR-UWYZ]\d[\dA-HJKPSTUW]?|[A-PR-UWYZ][A-HK-Y]\d[\dABEHMNPRVWXY]?) \d[ABD-HJLNP-UW-Z]{2})$/.test(a.postcode))
      return {field:'postcode',text:'Enter a valid UK postcode, for example BN1 1AA.'};
    if (/^(GY|JE|IM)/.test(a.postcode)) return {field:'postcode',text:'We deliver to UK addresses. This postcode is outside our delivery area.'};
    return null;
  }
  /* The postcodes the published shipping policy says "can take between 1-2
     days" (re-read 2026-09-29; _FACTS.md, "A few remote UK postcodes"). Same
     price, same UK service, just slower. PA2 is on the policy's list but is
     Paisley and looks like a typo for PA20, so it is deliberately left out
     until Verity says otherwise — _FACTS.md: "no page lists it as remote". */
  var REMOTE = [['AB',31,31],['AB',33,56],['FK',17,21],['HS',1,9],['IV',1,56],['IV',63,63],
    ['KA',27,28],['KW',1,3],['KW',5,17],['NE',68,68],['PA',20,49],['PA',60,78],
    ['PH',15,26],['PH',30,44],['PH',49,50],['TR',21,25],['ZE',1,3]];
  function remote(postcode) {
    var outward = normalise({postcode:postcode}).postcode.split(' ')[0];
    var m = /^([A-Z]{1,2})(\d{1,2})$/.exec(outward);
    if (!m) return false;
    var n = +m[2];
    return REMOTE.some(function (r) { return r[0] === m[1] && n >= r[1] && n <= r[2]; });
  }
  window.ADMAddress = {normalise:normalise,error:error,remote:remote};
})();
